import { useSyncExternalStore } from "react";

function subscribeToNothing(): () => void {
  return () => {};
}

function getClientSnapshot(): boolean {
  return true;
}

function getServerSnapshot(): boolean {
  return false;
}

/**
 * `false` during web server rendering AND the hydrating client render; `true` from then on.
 *
 * Gate anything whose markup differs between the server and the browser (a browser-only global, a
 * clock reading, a devtools overlay, a portal host that serializes differently) on this, so the
 * hydrating render matches the server HTML. A mismatch makes React discard the whole server tree
 * and re-render from scratch, which presents as a flash of unstyled content.
 *
 * `useSyncExternalStore` uses the server snapshot only while hydrating, then re-renders with the
 * client snapshot. A render that isn't hydrating (native, a web client-side mount, tests) is `true`
 * on its first render, with no extra effect-driven commit.
 */
export function useHasHydrated(): boolean {
  return useSyncExternalStore(subscribeToNothing, getClientSnapshot, getServerSnapshot);
}
